import { useNavigation } from "@react-navigation/native";
import { Colors, Spacings, View, Text } from "react-native-ui-lib";
import { Button } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../screens/SellScreen";
import { useTranslation } from "../../../../utilities/i18n";
import { moneyToFormattedString } from "@towersystems/roam-common/lib/shared-utils";

export const EmptyCart = () => {
  const navigation = useNavigation<SellScreenProps["navigation"]>();
  const { t } = useTranslation("pos");
  return (
    <View
      style={{
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <View style={{}}>
        <View row style={{ marginBottom: Spacings.s4 }}>
          <View marginR-10 flex>
            <Button
              isDestructive
              label="Empty Cart"
              fullWidth
              disabled={true}
            ></Button>
          </View>
          <View flex>
            <Button
              onPress={() =>
                navigation.navigate("ActionsRootScreen", {
                  screen: "MoreActionsScreen",
                })
              }
              isAction
              label="Actions"
              fullWidth
            ></Button>
          </View>
        </View>
      </View>
      <View>
        <Button
          backgroundColor={Colors.action}
          onPress={() => null}
          disabled={true}
        >
          <View
            style={{
              justifyContent: "space-between",
              flexDirection: "row",
              flex: 1,
              width: "100%",
              alignItems: "center",
              opacity: 0.8,
            }}
          >
            <View row style={{ alignItems: "center" }}>
              <Text
                color={Colors.text}
                style={{ fontSize: 22, fontWeight: "bold" }}
              >
                {t("common:pay")}
              </Text>
              <Text
                style={{
                  paddingLeft: Spacings.s4,
                  color: Colors.text,
                  opacity: 0.5,
                }}
              >
                (0 items)
              </Text>
            </View>
            <Text color={Colors.text} style={{ fontSize: 22 }}>
              {moneyToFormattedString(0)}
            </Text>
          </View>
        </Button>
      </View>
    </View>
  );
};
